import { useEffect, useMemo, useState } from "react";

import { ApiEndpoints, ApiResponse, getApiClient } from "../../api-http";
import { Event } from "./types";
import { useEventsLocale } from "./use-events-locale";

export function useGetEventDetail(eventId: string) {
  const [event, setEvent] = useState<Event | null>(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  const eventLocale = useEventsLocale();

  useEffect(() => {
    setLoading(true);
    const client = getApiClient({
      withCredentials: false,
      headers: {
        "Accept-Language": eventLocale,
      },
    });

    client
      .get<ApiResponse<Event>>(`${ApiEndpoints.EVENTS}/${eventId}`)
      .then(({ data: { data: event } }) => {
        setEvent(event);
      })
      .catch(() => {
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [eventId, eventLocale]);

  return useMemo(
    () => ({
      event,
      loading,
      error,
    }),
    [error, event, loading]
  );
}
